import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  legacy: true,
  silentFallbackWarn: true,
  messages: {
    'en-US': require('@/locales/en-US.json'),
  },
})
